import type { AttributeEditModeConfig } from '@source-components-react/types';
import { PLACEHOLDER_ICON } from './icon-attribute-value';

export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'icon-name-3-resolutions',
    heading: 'Icon',
    subHeading:
      'Search by name or by what the icon depicts (e.g. "launch" finds the rocket), for 3 different device resolutions',
    defaultValues: {
      all: PLACEHOLDER_ICON,
    },
  },
];
